<template>
  <div>
    <list-page-header />

    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="$can(Staff.actions.export, Staff.subject)"
      :columns="columns"
      :roles="roles"
      :bulkActions="tableBulkActions"
      :sortable="sortable"
      :sort-data="sortData"
      :formatTableData="formatTableData"
      mainField="full_name"
      selectable="multiple"
      ref="staffsTable"
      :permissionConfig="Staff"
    >
    </yv-index>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import Header from "./Header";
import { Staff } from "@/constants/Permissions";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { generateStatus } from "@/helpers/text-helper";

export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    const self = this;

    return {
      Staff,
      path: service_paths.staffs,
      formSearch: [
        {
          label: "staff.filter_by_role",
          name: "role_ids",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name"
        },
        {
          label: "staff.filter_by_workingStt",
          name: "status",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ]
        },
        {
          label: "common.username",
          name: "username__~",
          value: "",
          type: "input"
        },
        {
          label: "common.full_name",
          name: "full_name__~",
          value: "",
          type: "input"
        },
        {
          label: "common.phone_number",
          name: "phone_number__~",
          value: "",
          type: "input"
        },
        {
          label: "common.email",
          name: "email__~",
          value: "",
          type: "input"
        },
        {
          label: "common.source",
          name: "source",
          value: "",
          type: "select",
          is_switch_locale: "false",
          options: []
        },
        {
          label: "common.created_date",
          name: "created_date",
          value: [],
          type: "date-range",
          width: 35
        }
      ],
      roles: [],
      sortable: [
        "username",
        "staff_code",
        "full_name",
        "status",
        "phone_number",
        "email"
      ],
      sortData: {
        currentSort: "_id",
        currentSortOrder: "desc"
      },
      tableBulkActions: [
        {
          content: "common.delete",
          action: () => {
            self.confirmDelete();
          }
        }
      ],
      columns: {
        avatar_url: "staff.col_avatar",
        staff_code: "staff.col_staff_code",
        username: "common.username",
        full_name: "common.full_name",
        role_names: "staff.col_role",
        status: "common.status",
        assigned_students_quantity: "staff.col_assigned_students",
        email: "staff.col_email",
        source: "common.source",
        external_id: "External id"
      },
      generateStatus
    };
  },
  methods: {
    getLMSOptions() {
      return this.$axios.get(service_paths.lms).then(({ data }) => {
        if (data) {
          let newArr = [];
          data.data.map(el => {
            newArr.push({
              id: el.name,
              name: el.name
            });
          });
          this.formSearch[6].options = [...DEFAULT_OPTION_ALL, ...newArr];
        }
      });
    },
    async getStaffRoles() {
      const res = await this.$axios.get(`${service_paths.staffs}/roles`);
      const resData = res.data;
      this.formSearch[0].options = [...resData];
    },
    async deleteSelectedStaff() {
      const selectItems = this.$refs.staffsTable.selectedItems;
      let messageConfirmation = "";
      if (selectItems.length > 1) {
        messageConfirmation = this.$t("staff.the_selected_list_exists");
      } else {
        messageConfirmation = this.$t("staff.this_teacher_is_teaching");
      }

      const ids = selectItems.map(e => e.id || e._id);
      await this.$axios
        .patch(`${this.path}/delete/ids`, { ids }, {}, {}, messageConfirmation)
        .then(() => {
          Swal.fire({
            title: this.$t("staff.deleted"),
            text: this.$t("common.delete_success"),
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(error => {
          console.log(error);
        });

      // Reload table data
      this.$refs.staffsTable.getTableData();
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.you_wont_be_able_to_revert_this"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSelectedStaff();
        }
      });
    },
    formatTableData(tableData) {
      return tableData.map(staffData => {
        const numb = Math.random().toFixed(2) * 100000;
        const avatar_url =
          staffData.avatar_url || `https://picsum.photos/50/50?random=${numb}`;
        staffData.avatar_url = `<img src="${avatar_url}" class="object-cover rounded-full w-[42px] h-[42px]">`;
        staffData.staff_code =
          staffData.staff_code &&
          `<span class="font-semibold">${staffData.staff_code}</span>`;
        staffData.assigned_students_quantity =
          staffData.assigned_student_uuids &&
          staffData.assigned_student_uuids.length;
        staffData.external_id = this.generateExternalId(staffData.external_id);
        staffData.status = generateStatus(staffData.status);
        return staffData;
      });
    },
    generateExternalId(externalId) {
      if (!externalId) return "";
      const temp = [];
      Object.entries(externalId).map(item => {
        temp.push(`<p class="w-max inline-block">${item[0]}: ${item[1]}</p>`);
      });
      return temp.join("");
    }
  },
  mounted() {},
  created() {
    this.getStaffRoles();
    this.getLMSOptions();
  }
};
</script>

<style scoped lang="scss">
.md-button {
  border-radius: 100px !important;
}
</style>
